import declare from "dojo/_base/declare";
import domClass from "dojo/dom-class";
import query from "dojo/query";
import stateColorResolver from "csi/heading/stateColorResolver";
import html from "csi/html";
import StateWidget from "csi/html/StateWidget";
import locale from "csi/locale";
import xml from "csi/xml";

const PackListHeader = declare(StateWidget, {

	/**
     * @override
     * Process each element with a key according to its matching definition.
     */
	_processHtml: function(ctx, dom) {
		this.inherited(arguments);

		const node = ctx.getNode();
		const eDraft = query(".Draft", dom)[0];
		const eSubmitted = query(".Submitted", dom)[0];
		const eApproved = query(".Approved", dom)[0];
		const eAbandoned = query(".Abandoned", dom)[0];
		const css = stateColorResolver.getStateCss(node);

		const stateEnumValue = xml.enumGetText(node.State);

		switch (stateEnumValue) {
			case "DRAFT": domClass.add(eDraft, css); break;
			case "SUBMITTED": domClass.add(eSubmitted, css); break;
			case "APPROVED": domClass.add(eApproved, css); break;
			case "ABANDONED": domClass.add(eAbandoned, css); break;
		}

		if (eAbandoned) {
			html.text(eAbandoned, locale.getEnumName("PackListState:ABANDONED", true));
		} else {
			html.text(eDraft, locale.getEnumName("PackListState:DRAFT", true));
			html.text(eSubmitted, locale.getEnumName("PackListState:SUBMITTED", true));
			html.text(eApproved, locale.getEnumName("PackListState:APPROVED", true));
		}
	},
});

export = PackListHeader;
